import React from 'react';
import CustomLink from 'components/shared/CustomLink';
import type { CustomLinkProps } from 'components/shared/CustomLink';
import styles from './CTAComponent.module.css';

const cx = (...c: Array<string | false | undefined>) =>
  c.filter(Boolean).join(' ');

export const CTALink = React.forwardRef<HTMLAnchorElement, CustomLinkProps>(
  ({ className, ...props }, ref) => (
    <CustomLink
      ref={ref}
      {...props}
      className={cx(styles.ctaLink, className)}
    />
  ),
);
CTALink.displayName = 'CTALink';

export const PrimaryCTA = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { color?: 'blue' | 'black' }
>(({ color, className, ...props }, ref) => (
  <button
    ref={ref}
    {...props}
    data-color={color}
    className={cx(styles.primaryCta, className)}
  />
));
PrimaryCTA.displayName = 'PrimaryCTA';

export const SecondaryCTA = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button ref={ref} {...props} className={cx(styles.secondaryCta, className)} />
));
SecondaryCTA.displayName = 'SecondaryCTA';

export const FlatButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button ref={ref} {...props} className={cx(styles.flatButton, className)} />
));
FlatButton.displayName = 'FlatButton';

export const FlatLink = React.forwardRef<
  HTMLAnchorElement,
  CustomLinkProps & { color?: string }
>(({ color = '#000', className, style, ...props }, ref) => (
  <CustomLink
    ref={ref}
    {...props}
    style={{ ['--color' as any]: color, ...style }}
    className={cx(styles.flatLink, className)}
  />
));
FlatLink.displayName = 'FlatLink';

export const CTAButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button ref={ref} {...props} className={cx(styles.ctaButton, className)} />
));
CTAButton.displayName = 'CTAButton';

export const SecondaryButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button
    ref={ref}
    {...props}
    className={cx(styles.secondaryButton, className)}
  />
));
SecondaryButton.displayName = 'SecondaryButton';

export const BuyNowButton = React.forwardRef<
  HTMLAnchorElement,
  CustomLinkProps
>(({ className, ...props }, ref) => (
  <CustomLink
    ref={ref}
    {...props}
    className={cx(styles.buyNowButton, className)}
  />
));
BuyNowButton.displayName = 'BuyNowButton';
